module.exports = __webpack_public_path__ + "static/media/active.c0e46144.webp";